import { render } from "./IntroContent.vue?vue&type=template&id=61a06ba5&scoped=true&ts=true"
import script from "./IntroContent.vue?vue&type=script&lang=ts"
export * from "./IntroContent.vue?vue&type=script&lang=ts"

import "./IntroContent.vue?vue&type=style&index=0&id=61a06ba5&scoped=true&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a06ba5"]])

export default __exports__